import * as R from 'ramda';
import { ActionType } from '../../../core/redux/actionType';
import { AppState } from '../../../core/redux/appState';
import { Action } from 'redux';
import { Map } from '../../../language/models';
import { DevPlanFieldListItem } from './models';
import { DevPlanFieldAndAnswer } from '../models';


type SaveFieldAnswerListAction = {
  type: ActionType.SaveFieldAnswerList;
  languageId: number,
  devItemId: number,
  devActionId: number,
  compilationCategoryListIds: number[],
}


/**
 * Dispatch this action to save the user's field answer list selections locally (i.e., to prevent waiting on the API
 * to update).
 *
 * @param languageId - the database Id for the language in which the answers were selected
 * @param devItemId - the database Id for the development item containing the dev action
 * @param devActionId - the database Id for the development action
 * @param compilationCategoryListIds - the database Ids for the answers which comprise the dev field's answer list
 */
export const saveFieldAnswerListAction = (
  languageId: number,
  devItemId: number,
  devActionId: number,
  compilationCategoryListIds: number[],
): SaveFieldAnswerListAction => ({
  type:                       ActionType.SaveFieldAnswerList,
  languageId:                 languageId,
  devItemId:                  devItemId,
  devActionId:                devActionId,
  compilationCategoryListIds: compilationCategoryListIds,
});


export const saveFieldAnswerListReducer = (state: AppState, incomingAction: Action): AppState => {
  if (incomingAction.type !== ActionType.SaveFieldAnswerList) {
    return state;
  }

  const action = incomingAction as SaveFieldAnswerListAction;

  const { languageId, devItemId, devActionId, compilationCategoryListIds } = action;

  const listItems = R.path<Map<DevPlanFieldListItem> | undefined>(['devPlan', 'listItems', `${languageId}`], state);

  const fieldsAnswers = R.path<DevPlanFieldAndAnswer[] | undefined>(
    ['devPlan', 'fieldsAnswers', `${devItemId}`, `${devActionId}`],
    state,
  );

  const listFieldIndex = R.findIndex(f => f.list, fieldsAnswers ?? []);

  const answers = R.props(compilationCategoryListIds.map(compCatId => `${compCatId}`), listItems ?? {})
    .map(answer => answer.text);

  return R.assocPath(
    ['devPlan', 'fieldsAnswers', `${devItemId}`, `${devActionId}`, listFieldIndex, 'answers'],
    answers,
    state,
  );
};
